import React from 'react';
import { Box } from '@mui/material';
import Background from './Background';


const Forbidden = () => {

    return (
        <Box height={'92vh'} sx={{ position: 'relative' }}>
            <Background title="Welcome DigitAir" />
        </Box>
    );
};

export default Forbidden;
